import { Component, ViewChild} from '@angular/core';


import { AdministrationService } from '../../app/services/start';
import { GlobalVariable } from '../../app/app.global';
import { GoogleTagManagerService } from 'app/services/google-tag-manager.service';

@Component({
  selector: 'app',
  templateUrl: './main.html',
  providers:  [ AdministrationService ]
})

/**
 * @author Wesley Mascarenhas
 * @version $Id: main.component.ts 80218 2018-02-24 04:01:37Z bernardo.d.siqueira $
 */
export class MainComponent {
  private currentContent: string;

  constructor(private gtm: GoogleTagManagerService) {
    this.gtm.init();
    this.currentContent = 'main';
  }

  getCurrentContent(): String {
    return this.currentContent;
  }
}



// WEBPACK FOOTER //
// ./src/app/home/main.component.ts